import LoginSignup from "%/dynamic-component-editor/standard-pages/login-signup-page/LoginSignup.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyLoginSignup extends LegacyEntity {
  get elements() {
    return {
      LoginSignup,
    };
  }
}
